import { render, staticRenderFns } from "./hrmTagAssign.vue?vue&type=template&id=6131742f&"
import script from "./hrmTagAssign.vue?vue&type=script&lang=js&"
export * from "./hrmTagAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports